import {
  DEFAULT_AFTER_LOGIN_PATH,
  RETURN_URL_KEY,
} from "./session.constants";

function currentPath() {
  return `${window.location.pathname || ""}${window.location.search || ""}${
    window.location.hash || ""
  }`;
}

function pathnameOf(path) {
  const cut = path.search(/[?#]/);
  return cut === -1 ? path : path.slice(0, cut);
}

function isSkippable(path) {
  const pathname = pathnameOf(path);
  return (
    !pathname ||
    pathname === "/" ||
    pathname === "/goodbye" ||
    pathname.endsWith("/goodbye") ||
    pathname === "/health" ||
    pathname.endsWith("/health")
  );
}

function isSafeReturnPath(path) {
  return (
    typeof path === "string" &&
    path.startsWith("/") &&
    !path.startsWith("//") &&
    !path.includes("\\")
  );
}

function pathKey(path) {
  const cut = path.search(/[?#]/);
  const pathname = cut === -1 ? path : path.slice(0, cut);
  const extra = cut === -1 ? "" : path.slice(cut);
  return `${pathname.replace(/\/+$/, "") || "/"}${extra}`;
}

export function captureReturnUrl() {
  try {
    const path = currentPath();
    if (isSkippable(path) || !isSafeReturnPath(path)) {
      return;
    }
    localStorage.setItem(RETURN_URL_KEY, path);
  } catch {
    /* ignore */
  }
}

export function clearReturnUrl() {
  try {
    localStorage.removeItem(RETURN_URL_KEY);
  } catch {
    /* ignore */
  }
}

export function consumeReturnUrl() {
  try {
    const stored = localStorage.getItem(RETURN_URL_KEY);
    if (stored) {
      localStorage.removeItem(RETURN_URL_KEY);
      return isSafeReturnPath(stored) ? stored : DEFAULT_AFTER_LOGIN_PATH;
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_AFTER_LOGIN_PATH;
}

export function restoreReturnUrlAfterAuth() {
  let stored = null;
  try {
    stored = localStorage.getItem(RETURN_URL_KEY);
  } catch {
    return currentPath();
  }

  if (!stored) {
    return currentPath();
  }

  const url = consumeReturnUrl();
  if (pathKey(url) === pathKey(currentPath())) {
    return url;
  }

  if (typeof window.location.replace === "function") {
    window.location.replace(`${window.location.origin}${url}`);
  }
  return url;
}
